import {
  Edit,
  Trash2,
  // Info,
} from 'lucide-react'
import type { InventoryCategory } from '@/features/inventory/types/inventory'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/custom/badge'
import { usePermissions } from '@/utils/permissions'

interface CategoryCardProps {
  category: InventoryCategory
  onEdit: (itemId: string) => void
  onDelete: (itemId: string) => void
  onDetail: (itemId: string) => void
}

export function CategoryCard({
  category,
  onEdit,
  onDelete,
  // onDetail,
}: CategoryCardProps) {
  const permissions = usePermissions()

  return (
    <div className="border rounded-lg p-4 hover:shadow-md transition-shadow bg-white">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-lg">{category.name}</div>
        <Badge>{category.active ? 'Active' : 'Inactive'}</Badge>
      </div>
      {category.description && (
        <p className="text-sm text-neutral-600 mb-3">{category.description}</p>
      )}

      {/* Action Buttons */}
      <div className="flex justify-between items-center gap-2">
        {/* Details Button - only show for pastors */}
        {/* {permissions.isPastor() && (
          <Button
            variant="outline"
            size="sm"
            className="w-full sm:w-auto"
            onClick={() => onDetail(item._id)}
          >
            <Info className="h-4 w-4 sm:mr-2" /> Details
          </Button>
        )} */}

        <Button
          variant="outline"
          size="sm"
          className="flex-1"
          onClick={() => onEdit(category._id)}
        >
          <Edit className="h-4 w-4 sm:mr-2" /> Edit
        </Button>

        {permissions.canDeleteInventoryCategory() && (
          <Button
            variant="destructive"
            size="sm"
            className="flex-1"
            onClick={() => onDelete(category._id)}
          >
            <Trash2 className="h-4 w-4 sm:mr-2" /> Delete
          </Button>
        )}
      </div>
    </div>
  )
}
